import { makeStyles } from "@material-ui/core/styles";
export const TripsTabSupplierCss = makeStyles(theme => ({
    divV1: {
        display: 'flex',
        alignItems: 'center'
    },
    divV2: {
        color: '#0033cc',
        marginLeft: 6
    },
    noMatch: {
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#282f3d',
    },
    arrowRightV2: {
        fontSize: 24,
    },
    truckHireCost: {
        color: '#0b1323',
        textAlign: 'end'
    },
    supplierBalance: {
        color: 'red',
        textAlign: 'end'
    },
    STARTED_BULLET: {
        color: "#2680eb",
        fontSize: 12,
    },
    COMPLETED_BULLET: {
        color: "#00875a",
        fontSize: 12,
    },
    PAYMENT_RECEIVED_BULLET: {
        color: "grey",
        fontSize: 12,
    },
    POD_RECEIVED_BULLET: {
        color: "#2680eb",
        fontSize: 12,
    },
    POD_SUBMITTED_BULLET: {
        color: "#2680eb",
        fontSize: 12,
    },
    SETTLED_BULLET: {
        color: "#00875a",
        fontSize: 12,
    },
    statusDiv: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12
    },
    STARTED: {
        color: "#2680eb",
        fontSize: 12,
        marginLeft: 8
    },
    COMPLETED: {
        color: "#00875a",
        fontSize: 12,
        marginLeft: 8
    },
    PAYMENT_RECEIVED: {
        color: "grey",
        fontSize: 12,
        marginLeft: 8
    },
    POD_RECEIVED: {
        color: "#2680eb",
        fontSize: 12,
        marginLeft: 8
    },
    POD_SUBMITTED: {
        color: "#2680eb",
        fontSize: 12,
        marginLeft: 8
    },
    SETTLED: {
        color: "#00875a",
        fontSize: 12,
        marginLeft: 8
    },
    fwNormal: {
        fontWeight: 500
    },
    mtV2: {
        marginLeft: "-5em",
        display: 'flex',
    },
    mlV2: {
        marginLeft: 16
    },
    viewPDFCta: {
        backgroundColor: '#f27f36',
        borderRadius: 4,
        border: 0,
        color: 'white',
        height: 36,
        padding: '7px 16px 7px 12px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#f27f36'
        },
        fontWeight: 'normal',
        minWidth: 128
    },
    divV3: {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
    },
    divDate: {
        color: '#9ea0a5',
        fontSize: 13,
        textAlign: 'start',
        marginTop: '-20px'
    },
    divTripStatus: {
        color: '#9ea0a5',
        fontSize: 13,
        textAlign: 'start',
        marginTop: '-20px'
    },
    vehileNumber: {
        fontSize: 14,
        "&:last-child": {
            color: '#0033cc',
            marginLeft: 6
        },
        "&:nth-last-child(2)": {
            marginLeft: 6
        }
    },
    sparklineContainer: {
        padding: '12px 24px',
        borderRadius: '4px',
        border: 'solid 1px #eaedf3',
        display: 'flex'
    },
    infoCardIcon: {
        fontSize: 14,
        margin: '-2px 3px 0px 3px',
        color: '#A8A8A8',
        //float: 'right',
        cursor: 'pointer'
        // marginTop: 4
    },
    profit: {
        fontSize: 24,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.83,
        letterSpacing: 'normal',
        color: '#00875a',
        marginTop: 4,
        marginLeft: 16
    },
    loss: {
        fontSize: 24,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.83,
        letterSpacing: 'normal',
        color: '#ff0000',
        marginTop: 4,
        marginLeft: 16
    },
    sparklineTitle: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.5,
        color: '#6b778c',
        textTransform: 'uppercase',
        letterSpacing: 'normal'
    },
    divAlign: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    gridButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 60
    },
    sendMoneyCta: {
        padding: '7px 16px 7px 12px',
        borderRadius: 4,
        backgroundColor: '#1976d2',
        '&:hover': {
            backgroundColor: '#1976d2'
        },
        color: 'white',
        fontSize: 14,
        textTransform: 'capitalize',
        borderRadius: 4,
        border: 0,
        fontWeight: 'normal',
        minWidth: 146
    },
    mlV1: {
        marginLeft: 16
    },
    mlV3: {
        marginLeft: 8
    },
    viewTrip: {
        fontSize: 12,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.33,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#0033cc',
        textTransform: 'capitalize'
    },
    thTruckRightAlign: {
        backgroundColor: '#E3E8FD',
        border: '1px solid #dfe2e5',
        paddingBottom: 10,
        paddingTop: 10,
        textAlign: 'end',
        paddingLeft: 16,
        paddingRight: 16,
        position: 'sticky',
        zIndex: 100,
        top: '-1px !important'
    },
    thTruckCenterAlign: {
        backgroundColor: '#E3E8FD',
        border: '1px solid #dfe2e5',
        paddingBottom: 10,
        paddingTop: 10,
        textAlign: 'center',
        paddingLeft: 16,
        paddingRight: 16,
        position: 'sticky',
        zIndex: 100,
        top: '-1px !important'
    },
    rightArrow: {
        fontSize: 16,
        marginLeft: 8,
        marginTop: 1
    },
    iconButtonV1: {
        textTransform: 'capitalize',
        fontSize: 12,
        color: '#0033cc',
        padding: '7px 12px',
        borderRadius: '4px',
        border: '1px solid #0033cc',
        fontWeight: 300,
        width: 160
    },
    iconButtonV2: {
        textTransform: 'capitalize',
        fontSize: 12,
        color: 'white',
        padding: '7px 12px',
        borderRadius: '4px',
        border: '1px solid #0033cc',
        backgroundColor: '#0033cc',
        fontWeight: 300,
        width: 160,
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    }
}));

export const PassBookTabSupplierCss = makeStyles(theme => ({

    sparklineContainer: {
        padding: '12px 24px',
        borderRadius: '4px',
        border: 'solid 1px #eaedf3',
        display: 'flex'
    },
    sparklineTitle: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.5,
        color: '#6b778c',
        textTransform: 'uppercase',
        letterSpacing: 'normal'
    },
    infoCardIcon: {
        fontSize: 14,
        margin: '-2px 3px 0px 3px',
        color: '#A8A8A8',
        //float: 'right',
        cursor: 'pointer'
        // marginTop: 4
    },
    profit: {
        fontSize: 24,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.83,
        letterSpacing: 'normal',
        color: '#00875a',
        marginTop: 4,
        marginLeft: 16
    },
    loss: {
        fontSize: 24,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.83,
        letterSpacing: 'normal',
        color: '#ff0000',
        marginTop: 4,
        marginLeft: 16
    },
    gridButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 60
    },
    sendMoneyCta: {
        padding: '7px 16px 7px 12px',
        borderRadius: 4,
        backgroundColor: '#1976d2',
        '&:hover': {
            backgroundColor: '#1976d2'
        },
        color: 'white',
        fontSize: 14,
        textTransform: 'capitalize',
        borderRadius: 4,
        border: 0,
        fontWeight: 'normal',
        minWidth: 146
    },
    viewPDFCta: {
        backgroundColor: '#f27f36',
        borderRadius: 4,
        border: 0,
        color: 'white',
        height: 36,
        padding: '7px 16px 7px 12px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#f27f36'
        },
        fontWeight: 'normal',
        minWidth: 128
    },
    divAlign: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    divAlignV1: {
        display: 'flex',
        alignItems: 'center'
    },
    mlV3: {
        marginLeft: 8
    },
    mlV1: {
        marginLeft: 16
    },
    supplierTable: {
        '& .MuiTableRow-root': {
            //cursor: 'default',
        },
        /*'& .MUIDataTableToolbar-left-205': {
          display: 'none',
        },*/
        // '& div[class^="MUIDataTableToolbar-left-"]': {
        //     display: 'none'
        // }
    },
    mlV2: {
        marginLeft: 16
    },
    dotV1: {
        fontSize: '10px !important',
        color: '#d8d8d8',
        marginLeft: '8px',
        marginRight: '6px'
    },
    doneV1: {
        color: '#008556',
        fontSize: '14px !important',
        marginLeft: 8,
        marginRight: 8
    },
    paymentAmount: {
        textAlign: 'right',
        fontWeight: 'bold'
    },
    fwNormal: {
        fontWeight: 'normal'
    },
    tripInfo: {
        fontWeight: 500,
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.5)'
    },
    fw500: {
        fontWeight: 500
    },
    divVehicleNumber: {
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        '& :nth-last-child(2)': {
            marginLeft: 6
        },
        '& :last-child': {
            marginLeft: 6,
            color: '#0033cc'
        }
    },
    divExpense: {
        fontWeight: 'bold',
        lineheight: 1.43,
        textAlign: 'right',
        color: '#0033cc'
    },
    fwBold: {
        fontWeight: 'bold'
    },
    noMatch: {
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#282f3d'
    },
    thTruckRightAlign: {
        backgroundColor: '#E3E8FD',
        border: '1px solid #dfe2e5',
        paddingBottom: 10,
        paddingTop: 10,
        textAlign: 'end',
        paddingLeft: 16,
        paddingRight: 16,
        position: 'sticky',
        zIndex: 100,
        top: '-1px !important'
    },
    divTranstNo: {
        fontSize: '14px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.5)',
    },
    divPaymentStatus: {
        fontSize: 12,
        fontWeight: 500,
        color: '#ed8c46',
    },
    pendingIcon: {
        fontSize: 16,
        marginLeft: 8,
        marginRight: 8
    }
}));